export const DAY_CELL_WIDTH = 50;
export const ROLE_CELL_WIDTH = 200;
export const SELECT_CELL_WIDTH = 40;

export const BATCH_SIZE = 25; // Arbitrary number, don't think about it.
